import { FC, ReactNode } from 'react';
import CardHeaderTemplate from './CardHeaderTemplate';
import { Tooltip, ToolTipProps } from '../../../../shared/components/tooltip';
import InfoIcon from '../../../../assets/images/svg/InfoIcon';
import DownChevronIcon from '../../../../assets/images/svg/DownChevronIcon';
import { HeaderHeightKey } from '../types/CardTypes';

interface CardLabelHeaderProps {
  label: string;
  action?: ReactNode;
  onClick?: () => void;
  headerHeight: HeaderHeightKey;
  tooltip?: ToolTipProps;
  border?: boolean;
  hiddenDropDown?: [boolean, () => void, ReactNode];
  children?: ReactNode;
}

const CardLabelHeader: FC<CardLabelHeaderProps> = ({
  border = true,
  headerHeight,
  label,
  action,
  onClick,
  tooltip,
  children,
  hiddenDropDown,
}) => {
  return (
    <CardHeaderTemplate headerHeight={headerHeight} withBorder={border}>
      {hiddenDropDown ? (
        <div className='flex'>
          <button
            type='button'
            onClick={hiddenDropDown[1]}
            className='flex flex-row items-center text-lg font-semibold tracking-tight focus:outline-none'
          >
            <h2 className='mr-2 text-lg font-bold tracking-tight'>{label}</h2>
            {tooltip && (
              <Tooltip className='mb-2' label={tooltip.label} dir={tooltip.dir}>
                <InfoIcon />
              </Tooltip>
            )}
            <div
              className={`transform transition-all duration-300  ease-in-out ${
                hiddenDropDown[0] ? 'rotate-180' : 'rotate-0'
              }`}
            >
              <DownChevronIcon width='28' height='28' strokeWidth='3' />
            </div>
          </button>
          {hiddenDropDown[2]}
        </div>
      ) : (
        <div className='flex'>
          <h2 className='mr-2 text-lg font-bold tracking-tight'>{label}</h2>
          {tooltip && (
            <Tooltip label={tooltip.label} dir={tooltip.dir}>
              <InfoIcon />
            </Tooltip>
          )}
        </div>
      )}

      {action && (
        <div className='flex flex-row items-center justify-center text-base text-gray'>
          {onClick ? (
            <button className='focus:outline-none' onClick={onClick}>
              {action}
            </button>
          ) : (
            <span className='block'>{action}</span>
          )}
        </div>
      )}
      {children ? children : null}
    </CardHeaderTemplate>
  );
};

export default CardLabelHeader;
